var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 5.9933C8.41259 5.93278 4.70218 8.43991 2.36949 11.0076C2.12463 11.2794 1.98914 11.6323 1.98914 11.9981C1.98914 12.364 2.12463 12.7169 2.36949 12.9887C4.65145 15.5021 8.35118 18.067 12.0002 18.0056C15.6492 18.067 19.3498 15.5021 21.6335 12.9887C21.8784 12.7169 22.0139 12.364 22.0139 11.9981C22.0139 11.6323 21.8784 11.2794 21.6335 11.0076C19.2982 8.43991 15.5878 5.93278 12.0002 5.9933Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3375 12C15.3373 12.6601 15.1414 13.3053 14.7746 13.854C14.4077 14.4028 13.8864 14.8304 13.2766 15.0829C12.6667 15.3353 11.9957 15.4013 11.3483 15.2724C10.701 15.1435 10.1064 14.8256 9.63969 14.3588C9.17302 13.892 8.85525 13.2973 8.72654 12.6499C8.59783 12.0026 8.66398 11.3315 8.91661 10.7217C9.16925 10.1119 9.59702 9.59076 10.1459 9.22407C10.6947 8.85738 11.3399 8.66166 12 8.66166C12.4384 8.66154 12.8725 8.74782 13.2775 8.91556C13.6826 9.0833 14.0506 9.32921 14.3605 9.63924C14.6705 9.94928 14.9163 10.3173 15.0839 10.7224C15.2515 11.1275 15.3377 11.5617 15.3375 12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEyeOpen;